import { DatePickerInput, DatePickerInputProps } from '@mantine/dates';
import React from 'react';

type DateFieldProps = Omit<DatePickerInputProps<'default'>, 'type'>;

/**
 * Date-only input for forms. Matches DateTimeField (the LIA Assessment
 * Schedule form, which is the baseline for every menu) without the time part.
 */
const DateField: React.FC<DateFieldProps> = ({
  placeholder = 'Select date',
  valueFormat = 'DD/MM/YYYY',
  ...props
}) => <DatePickerInput placeholder={placeholder} valueFormat={valueFormat} {...props} />;

export default DateField;
